(() => {
  const CONFIGS = [
    { selector: '#halo-cart-sidebar .halo-sidebar-wrapper', side: 'left', rest: [6, 5], wide: [3.5, 9.5], arrow: 4.5 },
    { selector: '.halo-edit-cart-popup .halo-popup-content', side: 'right', rest: [5, 6], wide: [4, 8] },
    { selector: '#amazon-slide-drawer .amazon-drawer-content', side: 'right', rest: [5, 5], wide: [3, 9.5], arrow: 3.5, offset: (host) => {
      const drawer = host.closest('.amazon-slide-drawer');
      const panels = host.querySelector('.amazon-drawer-panels');
      if (drawer && !drawer.classList.contains('is-split') && panels && panels.classList.contains('show-sub')) return 0;
      const header = host.querySelector('.drawer-categories-header');
      return header && header.offsetParent ? header.getBoundingClientRect().height : 0;
    } },
    { selector: '#amazon-slide-drawer .amazon-drawer-panel-sub', side: 'right', rest: [5, 5], wide: [3, 9.5], arrow: 3.5, parent: '.amazon-slide-drawer', offset: (host) => {
      const heading = host.querySelector('.am2pm-sub-panel-heading');
      return heading && heading.offsetParent ? heading.getBoundingClientRect().height : 0;
    } }
  ];
  const RAIL = 16;
  const BUTTON = 22;
  const GAP = 5;
  const MIN_THUMB = 24;
  const STEP = 40;
  const instances = new Map();
  let styled = false;

  const injectStyle = () => {
    if (styled) return;
    styled = true;
    const arrow = (d) => `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 6'%3E%3Cpath d='${d}' fill='%237F7F7F'/%3E%3C/svg%3E")`;
    const style = document.createElement('style');
    style.textContent = `
.am2pm-csb-host{scrollbar-width:none!important}
.am2pm-csb-host::-webkit-scrollbar{display:none}
.am2pm-csb{position:absolute;z-index:20;width:${RAIL}px;user-select:none;-webkit-user-select:none;touch-action:none}
.am2pm-csb[hidden]{display:none}
.am2pm-csb__btn{display:block!important;position:absolute;left:0;width:100%;height:${BUTTON}px;background:transparent var(--csb-arrow-x,4px) center/8px 6px no-repeat;cursor:default}
.am2pm-csb__btn--up{top:0;background-position:left var(--csb-arrow-x,4px) bottom 3px;background-image:${arrow('M4 0l4 6H0z')}}
.am2pm-csb__btn--down{bottom:0;background-position:left var(--csb-arrow-x,4px) top 3px;background-image:${arrow('M4 6L0 0h8z')}}
.am2pm-csb__track{display:block!important;position:absolute;left:0;width:100%;top:${BUTTON}px;bottom:${BUTTON}px}
.am2pm-csb.is-wide .am2pm-csb__track{background:linear-gradient(#E6E6E6,#E6E6E6) var(--csb-track-x,0px) ${GAP}px/var(--csb-track-w,100%) calc(100% - ${GAP * 2}px) no-repeat}
.am2pm-csb__thumb{display:block!important;position:absolute;top:0;border-radius:7px;background:#7F7F7F}
.am2pm-csb.am2pm-csb--flat .am2pm-csb__btn{display:none!important}
.am2pm-csb.am2pm-csb--flat .am2pm-csb__track{top:0;bottom:0;background:#f1f1f1}
.am2pm-csb.am2pm-csb--flat .am2pm-csb__thumb{border-radius:5.2px;background:#888}
.am2pm-csb.am2pm-csb--flat .am2pm-csb__thumb:hover{background:#555}
`;
    document.head.appendChild(style);
  };

  const create = (host, config) => {
    const parent = config.parent ? host.closest(config.parent) : host.parentElement;
    if (!parent) return null;
    if (getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
    const rail = document.createElement('div');
    rail.className = config.flat ? 'am2pm-csb am2pm-csb--flat' : 'am2pm-csb';
    rail.setAttribute('aria-hidden', 'true');
    if (config.arrow) rail.style.setProperty('--csb-arrow-x', config.arrow + 'px');
    if (config.wide) {
      rail.style.setProperty('--csb-track-x', config.wide[0] + 'px');
      rail.style.setProperty('--csb-track-w', config.wide[1] + 'px');
    }
    rail.innerHTML = '<div class="am2pm-csb__btn am2pm-csb__btn--up"></div><div class="am2pm-csb__track"><div class="am2pm-csb__thumb"></div></div><div class="am2pm-csb__btn am2pm-csb__btn--down"></div>';
    parent.appendChild(rail);
    host.classList.add('am2pm-csb-host');
    const inst = {
      host, config, rail, parent,
      track: rail.querySelector('.am2pm-csb__track'),
      thumb: rail.querySelector('.am2pm-csb__thumb'),
      hover: false, dragging: false, raf: 0
    };
    bind(inst);
    update(inst);
    return inst;
  };

  const metrics = (inst) => {
    const { host, track } = inst;
    const trackLen = track.clientHeight;
    const max = host.scrollHeight - host.clientHeight;
    const thumbLen = Math.max(MIN_THUMB, Math.round(trackLen * host.clientHeight / host.scrollHeight));
    return { trackLen, max, thumbLen, room: Math.max(trackLen - thumbLen, 1) };
  };

  const update = (inst) => {
    inst.raf = 0;
    const { host, rail, thumb, config } = inst;
    const scrollable = host.scrollHeight - host.clientHeight > 1 && host.clientHeight > 0;
    const padProp = config.side === 'left' ? 'paddingLeft' : 'paddingRight';
    const railWidth = config.flat || RAIL;
    host.style[padProp] = scrollable ? railWidth + 'px' : '';
    rail.hidden = !scrollable;
    if (!scrollable) return;
    const parentRect = inst.parent.getBoundingClientRect();
    const rect = host.getBoundingClientRect();
    const top = rect.top - parentRect.top - inst.parent.clientTop;
    const left = rect.left - parentRect.left - inst.parent.clientLeft;
    const offset = config.offset ? config.offset(host) : 0;
    rail.style.top = (top + offset) + 'px';
    rail.style.height = Math.max(host.clientHeight - offset - (config.bottom || 0), 0) + 'px';
    rail.style.width = railWidth + 'px';
    rail.style.left = (config.side === 'left' ? left : left + rect.width - railWidth) + 'px';
    const wide = inst.hover || inst.dragging;
    rail.classList.toggle('is-wide', wide);
    const [x, w] = config.flat ? [0, railWidth] : (wide ? config.wide : config.rest);
    const m = metrics(inst);
    const pos = m.max > 0 ? Math.round(host.scrollTop / m.max * m.room) : 0;
    thumb.style.left = x + 'px';
    thumb.style.width = w + 'px';
    thumb.style.height = m.thumbLen + 'px';
    thumb.style.transform = 'translateY(' + pos + 'px)';
  };

  const queue = (inst) => {
    if (!inst.raf) inst.raf = requestAnimationFrame(() => update(inst));
  };

  const repeatWhilePressed = (event, fn) => {
    event.preventDefault();
    fn();
    let timer = setTimeout(function tick() {
      fn();
      timer = setTimeout(tick, 60);
    }, 350);
    const stop = () => {
      clearTimeout(timer);
      window.removeEventListener('pointerup', stop);
      window.removeEventListener('pointercancel', stop);
    };
    window.addEventListener('pointerup', stop);
    window.addEventListener('pointercancel', stop);
  };

  const bind = (inst) => {
    const { host, rail, track, thumb } = inst;
    const setHover = (value) => {
      if (inst.hover === value) return;
      inst.hover = value;
      queue(inst);
    };
    const inside = (node) => node && rail.contains(node);
    host.addEventListener('scroll', () => queue(inst), { passive: true });
    rail.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') setHover(true); });
    rail.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') setHover(false); });
    rail.addEventListener('wheel', (e) => {
      e.preventDefault();
      host.scrollTop += e.deltaMode === 1 ? e.deltaY * STEP : e.deltaY;
    }, { passive: false });
    rail.querySelector('.am2pm-csb__btn--up').addEventListener('pointerdown', (e) => repeatWhilePressed(e, () => { host.scrollTop -= STEP; }));
    rail.querySelector('.am2pm-csb__btn--down').addEventListener('pointerdown', (e) => repeatWhilePressed(e, () => { host.scrollTop += STEP; }));
    track.addEventListener('pointerdown', (e) => {
      if (e.target === thumb) return;
      const thumbRect = thumb.getBoundingClientRect();
      const dir = e.clientY < thumbRect.top ? -1 : 1;
      repeatWhilePressed(e, () => {
        const r = thumb.getBoundingClientRect();
        if ((dir < 0 && e.clientY < r.top) || (dir > 0 && e.clientY > r.bottom)) host.scrollTop += dir * host.clientHeight * 0.9;
      });
    });
    thumb.addEventListener('pointerdown', (e) => {
      e.preventDefault();
      const startY = e.clientY;
      const startTop = host.scrollTop;
      const m = metrics(inst);
      inst.dragging = true;
      queue(inst);
      thumb.setPointerCapture(e.pointerId);
      const move = (ev) => { host.scrollTop = startTop + (ev.clientY - startY) * m.max / m.room; };
      const end = (ev) => {
        inst.dragging = false;
        thumb.removeEventListener('pointermove', move);
        thumb.removeEventListener('pointerup', end);
        thumb.removeEventListener('pointercancel', end);
        if (!inside(document.elementFromPoint(ev.clientX, ev.clientY))) inst.hover = false;
        queue(inst);
      };
      thumb.addEventListener('pointermove', move);
      thumb.addEventListener('pointerup', end);
      thumb.addEventListener('pointercancel', end);
    });
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => queue(inst));
      ro.observe(host);
      ro.observe(inst.parent);
      inst.ro = ro;
    }
    const mo = new MutationObserver(() => queue(inst));
    mo.observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open'] });
    inst.mo = mo;
  };

  const scan = () => {
    CONFIGS.forEach((config) => {
      document.querySelectorAll(config.selector).forEach((host) => {
        const existing = instances.get(host);
        if (existing && existing.rail.isConnected && existing.rail.parentElement === existing.parent) {
          queue(existing);
          return;
        }
        if (existing) existing.rail.remove();
        const inst = create(host, config);
        if (inst) instances.set(host, inst);
      });
    });
  };

  const start = (force) => {
    const native = window.CSS && CSS.supports && CSS.supports('selector(::-webkit-scrollbar)');
    if (native && !force) return;
    injectStyle();
    scan();
    if (start.bound) return;
    start.bound = true;
    const rescan = () => { scan(); setTimeout(scan, 400); setTimeout(scan, 1500); };
    document.addEventListener('click', rescan, true);
    window.addEventListener('resize', () => instances.forEach(queue));
    new MutationObserver(() => instances.forEach(queue)).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  };

  window.am2pmCustomScrollbars = start;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start(false), { once: true });
  } else {
    start(false);
  }
})();
